
import React from 'react';
import { View } from '@dbk/ui-react-utils';
import { createContainer } from '@dbk-legacy/muster/react';
import { Checkbox } from '@dbk/ui-forms';
import Text, { Large } from '@dbk/ui-text';
import { PALETTE } from '../../../../constants';

const AdvicesSelectAll = (props) => {
  const { i18n: { messages }, handleSelectAllClick, isSelectAllChecked} = props;
  return (
    <div className="adviceCheckboxRow">
      <Checkbox
        className="checkboxClass"
        label={<Text numberOfLines={1} ellipsizeMode={'tail'} className="selectCheckBox" style= { isSelectAllChecked ? {color:PALETTE.primaryActive }  : { color:"#a7a8aa"}}>{messages['app.chedelivery.reports.selectAll']}</Text>}  
        onChange={handleSelectAllClick}
        checked={isSelectAllChecked}
      />
    </div>
  );
}

export default createContainer(
  {
    $queries: {
      i18n: {
        messages: true,
      },
    },
  },

)(AdvicesSelectAll);
